import { useEffect } from 'react';
import { UncontrolledTooltip } from 'reactstrap';

import { STUDY_SPEED_SETTINGS } from '../constants/StudySpeedSettings';

function StudySpeedSettingsSection({
  studySpeedSetting,
  studySpeedSettingsMessage,
  isLoadingStudySpeedSettings,
  setStudySpeedSettings,
  setStudySpeedSettingsMessage,
}) {
  useEffect(() => {
    let timeoutId;

    if (studySpeedSettingsMessage.message) {
      timeoutId = setTimeout(() => {
        setStudySpeedSettingsMessage({
          message: '',
          type: '',
        });
      }, 7000);
    }

    return () => {
      clearTimeout(timeoutId);
    };
  }, [studySpeedSettingsMessage]);

  const handleChangeStudySpeedSettings = (setting) => {
    if (!isLoadingStudySpeedSettings) {
      setStudySpeedSettings(setting);
    }
  };

  return (
    <section className="profile-privacy mb-4">
      <div className="profile-privacy-header">
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
          }}
        >
          <p className="label mb-2 ml-2">Choose Study Speed Settings</p>
        </div>
      </div>
      <div className="profile-privacy-body">
        <div className="radio-group mt-2 mb-2 flex-column flex-wrap study-speed__radio__container">
          <div className="radio-container">
            {studySpeedSetting === STUDY_SPEED_SETTINGS.ALL_NEW ? (
              <i className="material-icons radio-icon">radio_button_checked</i>
            ) : (
              <i
                className="material-icons radio-icon"
                onClick={() =>
                  handleChangeStudySpeedSettings(STUDY_SPEED_SETTINGS.ALL_NEW)
                }
              >
                radio_button_unchecked
              </i>
            )}
            <span
              id="flank-speed-tooltip"
              className="radio-label question__cursor__study__speed"
            >
              Supersonic
            </span>
            <UncontrolledTooltip placement="top" target="flank-speed-tooltip">
              Maximum effort to cover new content. Suitable for those familiar
              with the material or revisiting the exam.
            </UncontrolledTooltip>
          </div>
          <div className="radio-container">
            {studySpeedSetting === STUDY_SPEED_SETTINGS.MOSTLY_NEW ? (
              <i className="material-icons radio-icon">radio_button_checked</i>
            ) : (
              <i
                className="material-icons radio-icon"
                onClick={() =>
                  handleChangeStudySpeedSettings(
                    STUDY_SPEED_SETTINGS.MOSTLY_NEW,
                  )
                }
              >
                radio_button_unchecked
              </i>
            )}
            <span
              id="full-speed-tooltip"
              className="radio-label question__cursor__study__speed"
            >
              Intercept Speed
            </span>
            <UncontrolledTooltip placement="top" target="full-speed-tooltip">
              Prioritize new content while occasionally revisiting old material.
            </UncontrolledTooltip>
          </div>
          <div className="radio-container">
            {studySpeedSetting === STUDY_SPEED_SETTINGS.DEFAULT ? (
              <i className="material-icons radio-icon">radio_button_checked</i>
            ) : (
              <i
                className="material-icons radio-icon"
                onClick={() =>
                  handleChangeStudySpeedSettings(STUDY_SPEED_SETTINGS.DEFAULT)
                }
              >
                radio_button_unchecked
              </i>
            )}
            <span
              id="standard-speed-tooltip"
              className="radio-label question__cursor__study__speed"
            >
              Cruising Speed
            </span>
            <UncontrolledTooltip
              placement="top"
              target="standard-speed-tooltip"
            >
              A cautious pace, suitable for thorough comprehension and
              retention. The material is determined by our spaced repetition
              algorithm.
            </UncontrolledTooltip>
          </div>
          <div className="radio-container half-speed__container">
            {studySpeedSetting === STUDY_SPEED_SETTINGS.BALANCED ? (
              <i className="material-icons radio-icon">radio_button_checked</i>
            ) : (
              <i
                className="material-icons radio-icon"
                onClick={() =>
                  handleChangeStudySpeedSettings(STUDY_SPEED_SETTINGS.BALANCED)
                }
              >
                radio_button_unchecked
              </i>
            )}
            <span
              id="half-speed-tooltip"
              className="radio-label question__cursor__study__speed"
            >
              Landing Speed
            </span>
            <UncontrolledTooltip placement="top" target="half-speed-tooltip">
              A balanced approach, ensuring both new topics are explored and
              previously studied material is consolidated.
            </UncontrolledTooltip>
          </div>
          <div className="radio-container">
            {studySpeedSetting === STUDY_SPEED_SETTINGS.MOSTLY_REVIEW ? (
              <i className="material-icons radio-icon">radio_button_checked</i>
            ) : (
              <i
                className="material-icons radio-icon"
                onClick={() =>
                  handleChangeStudySpeedSettings(
                    STUDY_SPEED_SETTINGS.MOSTLY_REVIEW,
                  )
                }
              >
                radio_button_unchecked
              </i>
            )}
            <span
              id="slow-speed-tooltip"
              className="radio-label question__cursor__study__speed"
            >
              Taxi Speed
            </span>
            <UncontrolledTooltip placement="top" target="slow-speed-tooltip">
              Focus on reinforcing and mastering known content, with some forays
              into new areas.
            </UncontrolledTooltip>
          </div>
        </div>
      </div>
      {studySpeedSettingsMessage.message ? (
        <span className={`message-${studySpeedSettingsMessage.type}`}>
          {studySpeedSettingsMessage.message}
        </span>
      ) : null}
    </section>
  );
}

export default StudySpeedSettingsSection;
